import { render, staticRenderFns } from "./RsaConfigurazioneModalitaSomministrazioneListPage.vue?vue&type=template&id=39c78d76&scoped=true"
import script from "./RsaConfigurazioneModalitaSomministrazioneListPage.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneModalitaSomministrazioneListPage.vue?vue&type=script&lang=js"
import style0 from "./RsaConfigurazioneModalitaSomministrazioneListPage.vue?vue&type=style&index=0&id=39c78d76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c78d76",
  null
  
)

export default component.exports